const fixAnchorPosition = function () {
    let anchorName = window.location.hash

    if (anchorName === '') {
        return
    }
    anchorName = anchorName.replace('#', '')

    let element = document.getElementById(anchorName)
    if (element === null) {
        return
    }

    let bodyRect = document.body.getBoundingClientRect(),
        elemRect = element.getBoundingClientRect(),
        offset = elemRect.top - bodyRect.top

    let headerSize = document.querySelector('.header__container').offsetHeight
    window.scrollTo(0, offset - headerSize)
}

if (document.readyState !== 'loading') {
    document.addEventListener('afterHubSpotFormLoadedCompletelyEvent', function () {
        fixAnchorPosition()
    })
}
